import '@/style/index.less';
import 'tdesign-vue-next/es/style/index.css';
import './permission';

import { Loading } from 'tdesign-vue-next';
import { createApp } from 'vue';

import { permission } from '@/directives/permission';

import App from './App.vue';
import { i18n } from './locales';
import router from './router';
import { store } from './store';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(i18n);
app.use(Loading);

// 注册权限指令
app.directive('permission', permission);

app.mount('#app');
